export const locale2lang = (locale: string): string => {
    const dashIndex = locale.indexOf("-");
    return dashIndex > 0 ? locale.substring(0, dashIndex) : locale;
};

export default locale2lang;
